//components/Cart/Cart.jsx
import React from "react";
import { Link } from "react-router-dom";

// CSS
import "./cart.css";

// Context
import { useCart } from "../../context/CartContext";

// Icons
import { FaMinus, FaPlus } from "react-icons/fa";

const Cart = () => {
  const { cart, setCart } = useCart();

  const updateQuantity = (id, amount, replace = false) => {
    const updatedCart = cart.map((item) =>
      item._id === id
        ? {
            ...item,
            quantity: replace
              ? Math.max(1, amount)
              : Math.max(1, item.quantity + amount),
          }
        : item,
    );
    setCart(updatedCart);
    // console.log(cart);
  };

  const removeItem = (id) => {
    const updatedCart = cart.filter((item) => item._id !== id);
    setCart(updatedCart);

    if (updatedCart.length === 0) {
      localStorage.removeItem("cart");
      localStorage.removeItem("cartTimestamp");
    }
  };

  return (
    <section className="cart" id="cart">
      <div className="cart-container">
        <h2 className="cart-heading">Your Cart</h2>

        {cart.length === 0 ? (
          <div className="cart-empty">
            <p className="cart-empty-text">Your cart is empty!</p>
            <Link to="/menu" className="btn btn-primary">
              Browse Menu
            </Link>
          </div>
        ) : null}

        <div className="cart-items">
          {cart.map((item) => (
            <div key={item._id} className="cart-item">
              <div className="cart-item-details">
                <img
                  // src={item.imageUrl[0]}
                  src={
                    Array.isArray(item.imageUrl)
                      ? item.imageUrl[0]
                      : item.imageUrl
                  }
                  alt={item.title}
                  className="cart-item-img"
                />
                <h3 className="cart-item-title">{item.title}</h3>
                <p className="cart-item-price">৳{item.price}</p>
              </div>

              <div className="cart-item-order">
                <div className="cart-item-quantity-container">
                  <FaMinus
                    className="quantity-minus"
                    onClick={() => updateQuantity(item._id, -1)}
                  />
                  <input
                    type="number"
                    className="cart-item-quantity"
                    value={item.quantity}
                    min="1"
                    onChange={(e) => {
                      let value = parseInt(e.target.value, 10);
                      if (isNaN(value) || value < 1) value = 1;
                      updateQuantity(item._id, value, true);
                    }}
                  />
                  <FaPlus
                    className="quantity-plus"
                    onClick={() => updateQuantity(item._id, 1)}
                  />
                </div>

                <p className="cart-item-total">৳{item.price * item.quantity}</p>

                <button
                  onClick={() => removeItem(item._id)}
                  className="cart-item-remove-btn btn btn-secondary"
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>

        {cart.length === 0 ? null : (
          <>
            <h3 className="cart-grand-total">
              <span className="cart-grand-total-text">Grand Total:</span>
              <span className="cart-grand-total-amount">
                ৳
                {cart.reduce(
                  (sum, item) => sum + item.price * item.quantity,
                  0,
                )}
              </span>
              {/* <br />
              <span>{"( - ৳50 off on each item)"}</span> */}
            </h3>
            <p className=" text-center text-[30px] font-bold mb-[-15px]">+</p>
            <h3 className="cart-grand-total">
              <span className="cart-grand-total-text">Delivery Charge:</span>
              <span className="cart-grand-total-amount">৳50</span>
            </h3>

            <div className="cart-cta">
              <a
                href="/order#order-form"
                className="place-order-btn btn btn-primary"
              >
                Place Order
              </a>
              <Link to="/menu" className="btn btn-secondary">
                Browse Menu
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Cart;
